import { useNavigate } from "react-router-dom";
import { ArrowLeft, Gamepad2, ChevronRight } from "lucide-react";

const GAMES = [
  { id: "wheel", name: "Spin the Wheel", emoji: "🎡", bg: "#F5A623", desc: "A random neighbor appears — the wheel lands on $5, $10, $20, $40, $50, or $100" },
  { id: "slots", name: "Slots", emoji: "🎰", bg: "#EF6B6B", desc: "3×3 grid of neighbors — match 3 in a row or column, then pick their gift amount" },
  { id: "blackjack", name: "Blackjack", emoji: "🃏", bg: "#1B5E3F", desc: "Beat the dealer to unlock a gift for a random neighbor — hit, stand, and pick your amount" },
  { id: "horse", name: "Horse Race", emoji: "🐎", bg: "#2E7D32", desc: "Up to 4 neighbors dash across the screen — the winner gets your gift" },
  { id: "neighbor-man", name: "Pac-Man", emoji: "👾", bg: "#4C6BFF", desc: "Dodge 4 ghosts through 10 mazes" },
  { id: "deal", name: "Deal or No Deal", emoji: "💼", bg: "#7C3AED", desc: "Open briefcases, dodge the Banker's lowball offers — deal or hold out to bless a neighbor" },
];

export default function GamesPage() {
  const navigate = useNavigate();
  return (
    <div className="max-w-2xl mx-auto pb-28">
      {/* Header */}
      <div className="relative flex items-center justify-center px-4 py-4 border-b border-border">
        <button data-testid="games-back" onClick={() => navigate("/")} className="absolute left-4 w-10 h-10 rounded-pill grid place-items-center bg-surface-3 text-ink-tertiary"><ArrowLeft size={20} /></button>
        <h1 className="text-xl font-black">Mini Games</h1>
      </div>

      <div className="px-4 pt-5">
        <div className="rounded-lg p-5 mb-5" style={{ background: "var(--brand-tertiary)" }}>
          <div className="w-12 h-12 rounded-md grid place-items-center text-white mb-3" style={{ background: "#1E40AF" }}><Gamepad2 size={24} /></div>
          <h2 className="text-2xl font-black text-brand-primary">Fun ways to bless someone</h2>
          <p className="text-ink-tertiary font-semibold mt-1">Play a game, land on an amount, send it straight to a real neighbor.</p>
        </div>

        <div className="space-y-4">
          {GAMES.map((g) => (
            <button key={g.id} data-testid={`game-${g.id}`} onClick={() => navigate(`/games/${g.id}`)}
              className="w-full flex items-center gap-4 bg-surface-2 border border-border rounded-lg p-4 text-left hover:-translate-y-0.5 transition-transform">
              <div className="w-16 h-16 rounded-pill grid place-items-center text-3xl shrink-0" style={{ background: g.bg }}>{g.emoji}</div>
              <div className="flex-1 min-w-0">
                <div className="font-black text-xl">{g.name}</div>
                <div className="text-sm text-ink-tertiary leading-snug">{g.desc}</div>
              </div>
              <ChevronRight className="text-ink-tertiary shrink-0" size={22} />
            </button>
          ))}
        </div>

        <p className="text-center text-ink-tertiary font-semibold mt-6">More games coming soon. Got an idea? Tell us from your profile.</p>
      </div>
    </div>
  );
}
